<template>
    <div class="demo-page-container">
        <!-- 列表搜索过滤 -->
        <div class="search-wrap">
            <el-form
                :label-position="'left'"
                :model="searchForm"
                :inline="true"
                class="leader-style-form"
                ref="searchForm"
            >
                <el-form-item label="公司名称">
                    <el-input v-model="cust_name" maxlength="50"></el-input>
                </el-form-item>
                <el-form-item label="采集点名称">
                    <el-input v-model="point_name" maxlength="50"></el-input>
                </el-form-item>
                <el-form-item label="日期" label-width="40px" prop="name">
                    <el-date-picker
                        style="height: 36px"
                        v-model="date"
                        :picker-options="pickerOptions"
                        type="date"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        @change="handleFilterList()"
                        placeholder="选择日期"
                    ></el-date-picker>
                </el-form-item>
                <el-button size="medium" class="leader-common-button" @click="handleFilterList()">查询</el-button>
            </el-form>
        </div>
        <!-- 列表 -->
        <div class="table-wrap">
            <el-scrollbar style="height: 90%">
                <el-table
                    border
                    :data="tableList"
                    highlight-current-row
                    class="leader-style-table"
                    style="width: 100%"
                >
                    <el-table-column width="50" align="center" label="序号">
                        <template slot-scope="scope">
                            <span>
                                {{
                                    (pageNum - 1) * pageSize + scope.$index + 1
                                }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="公司名称" property="cust_name" align="center"></el-table-column>
                    <el-table-column label="采集点名称" property="point_name" align="center"></el-table-column>
                    <el-table-column label="应采条数" property="should_count" align="center"></el-table-column>
                    <el-table-column label="实采条数" property="real_count" align="center"></el-table-column>
                    <el-table-column label="成功率(%)" property="success_rate" align="center"></el-table-column>
                </el-table>
            </el-scrollbar>

            <el-pagination
                class="leader-style-pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
import * as api1 from "@/http/api.js";
import moment from "moment";
export default {
    data() {
        return {
            tableList: [], //列表list
            freeze_dataList: [], //列表list
            collectorList: [], //列表list
            pageNum: 1, //页码
            pageSize: 10, //每页条数
            factory_no: 0, //出厂编号
            currentPage: 1, //当前页码
            totalNum: 0, //总条数
            loading: false, //loading状态
            date: "",
            cust_name: "",
            point_name: "",
            nextTimeDisabled: true,
            systemDate: "",
            pickerOptions: {
                disabledDate(time) {
                    return (
                        time.getTime() >
                        new Date(new Date() - 24 * 60 * 60 * 1000)
                    );
                }
            }
        };
    },
    created() {
        this.getSysDate();
    },
    methods: {
        handleFilterList() {

            this.getAbnormalList();

        },
        getSysDate() {
            api1.getSysDate().then(res => {
                if (res && res.error_code === "0") {
                    // this.date = res.bus_json.sysdate;
                    this.date = moment(new Date(res.bus_json.sysdate))
                        .subtract(1, "days")
                        .format("YYYY-MM-DD");
                    this.systemDate = this.date;
                    this.getAbnormalList();
                }
            });
        },
        /**
         * 获取demo列表
         */
        getAbnormalList() {
            this.loading = true;
            api1.getAbnormalList({
                show_day: this.date,
                cust_name: this.cust_name,
                point_name: this.point_name,
                pageNum: this.pageNum,
                pageSize: this.pageSize
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.tableList = res.bus_json.items;
                    this.totalNum = res.bus_json.totalNum;
                }
                this.loading = false;
            });
        },
        /**
         * 列表条数改变回调
         */
        handleSizeChange(e) {
            this.pageNum = 1;
            this.pageSize = e;
            this.getAbnormalList();
        },
        /**
         * 企业列表页码改变回调
         */
        handleCurrentChange(e) {
            this.pageNum = e;
            this.getAbnormalList();
        },
    }
};
</script>
<style lang="scss">
.demo-page-container {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: px2Rem(20px);

    .el-pagination {
        margin-top: 20px;
    }

    .button-green {
        color: #40be6c;
    }

    .button-red {
        color: #ff8971;
    }

    .button-blue {
        color: #0090e7;
    }

    .el-select {
        width: 100%;
    }

    .split-line {
        width: 2px;
        height: 12px;
        background: #adadad;
        display: inline-block;
        margin: 0 8px;
        vertical-align: middle;
    }

    .search-btn-wrap {
        text-align: right;
    }

    .search-wrap {
        .button-group {
            display: inline-block;
            margin-left: 20px;
            button {
                background: rgb(41, 184, 94);
                color: white;
                outline: none;
                border-color: rgb(41, 184, 94);
            }
            .el-button.is-disabled,
            .el-button.is-disabled:focus,
            .el-button.is-disabled:hover {
                border-color: #ebeef5;
            }
        }
    }
}
</style>
